import React, { useState } from 'react';
import ActivityLoader from '../Common/ActivityLoader';
import BsModal from '../Common/BsModal';
import { useTheme } from '../../DataStore/ThemeContext';
import Notification from '../Common/Notification';
import ajaxPeriod from '../../util/remote/ajaxPeriod';

const AlertSwitchPeriod = ({show, handleClose, selection}) => {

    const [loading, setLoading] = useState(false);
    const {setNotify} = useTheme();


    const confirm = async()=>{
        setLoading(true);
        const server_response = await ajaxPeriod.switchPeriod(selection.period_id);
        setLoading(false);
        if(server_response.status === "OK"){
            setNotify(<Notification type='success' message={server_response.message}/>)
            window.location.reload();
        }else{
            setNotify(<Notification type='danger' message={server_response.message}/>)
        }
        handleClose();
    }

    return (
        <BsModal
            show={show}
            onClose={handleClose}
            title="Switch Financial Period"
            footer={
                <>
                    {loading && <ActivityLoader />}
                    {!loading && <>
                    <button className="btn btn-secondary" onClick={handleClose}>
                        Cancel
                    </button>
                    <button className="btn btn-danger" onClick={confirm}>
                        Confirm Switch
                    </button>
                    </>}
                </>
            }
        >


            <div className="d-flex justify-content-center align-items-center flex-column">
                <i 
                className="fa fa-question-circle text-danger" 
                style={{ fontSize: "40px", lineHeight: "1", marginTop: "20px" }}
                ></i>
                <h5 className='mt-1 text-dark text-center' style={{fontSize: '17px'}}>{`Are you sure you want to switch to the selected financial period ${selection.opening_date.short_date} - ${selection.closing_date.short_date} ?`}</h5>

                <p className="mb-4 mt-2 text-secondary">
                <b>Note: </b> All users will be affected by this change and all transactions will be locked for the previous period.
                </p>
           
            </div>
          

        </BsModal>
    );
};

export default AlertSwitchPeriod;
